import { calculateEmissions, isValidCalculatorName } from '@aginnovationaustralia/emissions-calculators3.0.0';
import { Processor, ProcessorResponse } from './types';

export const calc300: Processor = (calculatorName: string, input: unknown): ProcessorResponse => {
  try {
    if (!isValidCalculatorName(calculatorName)) {
      return {
        body: { error: `Calculator ${calculatorName} not found` },
        status: 404,
      };
    }

    const result = calculateEmissions(calculatorName, input, { organisation: 'AIA doc site' });

    if (result.status === 'OK') {
      return {
        body: result.emissions,
        status: 200,
      };
    } else if (result.status === 'INVALID_INPUT') {
      return {
        body: result,
        status: 422,
      };
    }
    return {
      body: { error: result.error.message },
      status: 500,
    };
  } catch (error) {
    console.error(`Error calculating ${calculatorName}:`, error);
    return {
      body: { error: `Error when processing ${calculatorName} calculator: ${error}` },
      status: 500,
    };
  }
};
